import { InnoveraIcon } from "@libs/zapi-ui/assets";
import { useTranslation } from "react-i18next";
import { AppButton, FigmaTypography } from "@libs/zapi-ui/custom";
import { BookOpenIcon } from "@phosphor-icons/react";
import { useMeStore } from "@/zapi-frontend/shared/hooks/useMe";
import { hasEditAccess } from "@/zapi-frontend/shared/utils/permissions";

type TOutlineEmptyProps = {
  onGenerate: () => void;
  onOpenInstructions?: () => void;
};

export function OutlineEmpty({ onGenerate, onOpenInstructions }: TOutlineEmptyProps) {
  const { t } = useTranslation("projectHome");
  const { isLabs, role, accessMode } = useMeStore();
  const hasEdit = hasEditAccess(role, accessMode);

  return (
    <div className="w-full min-w-0 h-full bg-white flex flex-col items-center justify-center px-4">

      <FigmaTypography variant="heading-2" color="zinc900" className="mb-2">
        {t("presentation.startTitle")}
      </FigmaTypography>
      <FigmaTypography variant="body-2" color="zinc500" className="mb-6 text-center">
        {t("presentation.startLine1")}
        <br />
        {t("presentation.startLine2")}
      </FigmaTypography>
      {hasEdit && (
        <div className="flex flex-wrap items-center justify-center gap-2">
          {isLabs && (
            <AppButton
              appearance="outlined"
              color="zinc150"
              startAdornment={<BookOpenIcon size={16} />}
              onClick={onOpenInstructions}
              className="min-w-[176px]"
            >
              {t("instructionsModal.outlineInstructions")}
            </AppButton>
          )}
          <AppButton
            onClick={onGenerate}
            className="min-w-[176px] [&_svg>path]:fill-white"
            startAdornment={<InnoveraIcon width={16} height={16} />}
            data-testid="presentation-generate-outline"
          >
            {t("presentation.createOutline")}
          </AppButton>
        </div>
      )}
    </div>
  );
}
